<template>
    <div id="body">
        <nav ref="btnNavi1" :style="{top: this.$route.params.NavBarHeight + 'px'}">
          <div class="naviDiv">
            <router-link ref="btnNavi" active-class="selected" @click.native="moveLine($event, index)" v-for="(item, index) in routers" :key="item[0]" :to="{ name: item[1], params: item[2] }">
                {{ item[0] }}
            </router-link>
          </div>
          <div class="lineDiv">
            <div class="line" :style="{'left': lineXPosition + 'px'}"></div>
          </div>
        </nav>
        <hr :style="{top: getTopWithNavBarHeight(44)}"/>

        <div v-touch:swipe='swipe'>
          <slot>
              content
          </slot>
        </div>
    </div>
</template>

<script>

export default {
  name: 'nav-list',
  props: {
    routers: { // [title, pathName, params]
      type: Array,
      required: true,
      default: () => []
    }
  },
  mounted () {
    this.resetLinePosition()
  },
  updated () {
    this.resetLinePosition()
  },
  methods: {
    moveLine: function (e, index) {
      this.lineXPosition = e.target.getBoundingClientRect().left + e.target.getBoundingClientRect().width / 2 - 8
      this.selectedIndex = index
    },
    resetLinePosition: function () {
      var el = this.$refs.btnNavi1.getElementsByTagName('selected')[0]
      if (el) {
        var newValue = el.getBoundingClientRect().left + el.getBoundingClientRect().width / 2 - 8
        if (this.lineXPosition !== newValue) {
          this.lineXPosition = newValue
        }
      } else {
        this.$refs.btnNavi[this.selectedIndex].$el.click()
      }
    },
    swipe: function (event) {
      if (this.ignoreSwipe) {
        this.ignoreSwipe = false
        return
      }

      if (event === 'left') {
        this.selectedIndex = this.selectedIndex + 1 === this.routers.length ? 0 : this.selectedIndex + 1
        this.$refs.btnNavi[this.selectedIndex].$el.click()
      } else if (event === 'right') {
        this.selectedIndex = this.selectedIndex - 1 < 0 ? this.routers.length - 1 : this.selectedIndex - 1
        this.$refs.btnNavi[this.selectedIndex].$el.click()
      }
    },
    getTopWithNavBarHeight: function (top) {
      return (top + parseInt(this.$route.params.NavBarHeight)) + 'px'
    }
  },
  data () {
    return {
      ignoreSwipe: false,
      lineXPosition: 0,
      selectedIndex: 0
    }
  }
}
</script>

<style lang="sass" scoped>
#body
    background-color: white

hr
    margin: 0
    border: none
    border-top: 1px solid #c8c8c8
    position: sticky
    z-index: 3000

nav
    height: 44px
    position: sticky
    background-color: white
    z-index: 3000
    .naviDiv
      width: 100%
      height: 44px
      display: flex
      justify-content: space-around
      a
        color: #999999
        text-decoration: none
        font-size: 15px
        align-self: center
      .selected
        color: #06b782
        font-weight: bold
        font-size: 17px
    .lineDiv
      position: relative
      .line
          height: 3px
          width: 17px
          border-radius: 1.5px
          position: absolute
          bottom: 2px
          font-size: 10px
          background-color: #06b782

.v-touch
    touch-action: pan-y!important
</style>
